(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["helpBox"]) return;
  try {
                                       
var lastSearch = "";
var mouseInResultBox = false;
var searchBoxOnfocus = false;
var searchBoxEmpty = false;
var noResult = false;
var min_marks = 100;
var max_result_items = 10;

//console.log(min_marks, max_result_items);

function searchFAQ(q) {
  $("#search-result-inner").html("");
  if (q.length <= 1) {
    noResult = false;
    return;
  }

  var matchedNum = getMatchedNumber(q, min_marks, max_result_items);

  //console.log(matchedNum); 
  if (matchedNum == null) {
    noResult = false;
    return;
  }

  var res_html = '<div class="res-item"><div class="res-cat">|catalog|(|marks|)</div><div class="res-qst">|question|</div><div class="res-ans">|ans|</div></div>';
  var html = '';

  for (var j = 0; j < matchedNum; j++) {
    var k = words[j].k, i = words[j].i;
    var ans = md2html(catList[k][i].answer);
    if (catList[k][i].answer1 != null && catList[k][i].answer1 != "") ans += "<br><br><span class='ans-dept'>Hong Kong:</span><br>" + md2html(catList[k][i].answer1);
    if (catList[k][i].answer2 != null && catList[k][i].answer2 != "") ans += "<br><br><span class='ans-dept'>MDF:</span><br>" + md2html(catList[k][i].answer2);
    if (catList[k][i].answer3 != null && catList[k][i].answer3 != "") ans += "<br><br><span class='ans-dept'>Others:</span><br>" + md2html(catList[k][i].answer3);

    if (ans == null || ans == "") ans = "Please contact us for more information.";

    html += res_html.replace(/\|[^\|]*\|/g, function (m) {
      var pm = m.replace(/\|/g, '');
      if (catList[k][i].hasOwnProperty(pm)) {
        return catList[k][i][pm];
      } else {
        switch (pm) {
          case "ans": return ans;
          case "marks": return words[j].marks;
        }
      }
      return m;
    });
  }

  noResult = (html == "");
  $("#search-result-inner").html(html);
  updateResultDisp();
}

function updateResultDisp() {
  var tar = $(".search-result").first();
  if (mouseInResultBox || (searchBoxOnfocus && !searchBoxEmpty)) {
    tar.removeClass("hide");
    $("#helpbox").addClass("helpbox-expand");
  } else {
    tar.addClass("hide");
    $("#helpbox").removeClass("helpbox-expand");
  }
}
$("#topic_filter").on("input", function () {
  var keyword = $(this).val();
  searchBoxEmpty = (keyword == "");
  updateResultDisp();
  setTimeout(function () {
    if (lastSearch == keyword) searchFAQ(lastSearch);
  }, 500);
  lastSearch = keyword;
});
$("#topic_filter").focus(function () {
  searchBoxOnfocus = true;
  updateResultDisp();
});
$("#topic_filter").blur(function () {
  searchBoxOnfocus = false;
  updateResultDisp();
});
$(document).mousemove(function (e) {
  var resbox = document.getElementById("search-result-inner").getBoundingClientRect();
  mouseInResultBox = (((e.clientX > resbox.left) && (e.clientX < resbox.right)) && ((e.clientY > resbox.top) && (e.clientY < resbox.bottom)));
});
$(document).mousedown(function (e) {
  updateResultDisp();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linkBoxes"] && !window.DesignMode) return;
  try {
    
  function shadeRGBColor(color, percent) {
    var f=color.split(","),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=parseInt(f[0].slice(4)),G=parseInt(f[1]),B=parseInt(f[2]);
    return "rgb("+(Math.round((t-R)*p)+R)+","+(Math.round((t-G)*p)+G)+","+(Math.round((t-B)*p)+B)+")";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["numberBoxes"] && !window.DesignMode) return;
  try {
    
  function shadeRGBColor(color, percent) {
    var f=color.split(","),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=parseInt(f[0].slice(4)),G=parseInt(f[1]),B=parseInt(f[2]);
    return "rgb("+(Math.round((t-R)*p)+R)+","+(Math.round((t-G)*p)+G)+","+(Math.round((t-B)*p)+B)+")";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
var pdData = {};
//json to Table
function jsonToTable(d) {
    if (typeof d === "string") return d;
    var cols = {}, th = "", tb = "", tmp = "";

    for (var i = 0; i < d.length; i++) {
        for (var k in d[i]) cols[k] = "";
    }

    tmp = "<tr>";
    for (var k in cols) tmp += "<td>" + k + "</td>";
    th += tmp + "</tr>";

    for (var i = 0; i < d.length; i++) {
        tmp = "<tr>";
        for (var k in cols) {
            tmp += "<td>";
            if (d[i].hasOwnProperty(k)) tmp += d[i][k];
            tmp += "</td>";
        }
        tb += tmp + "</tr>";
    }
    return "<table><thead>" + th + "</thead><tbody>" + tb + "</tbody></table>";
}

jQuery.post("http://glpopsys.com/glpop/getproduct.php?pid={{ product.title }}", function (data) {
    var pdData = JSON.parse(data);
    $("#pd_data").html(jsonToTable(pdData.spaces));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search_faq"]) return;
  try {
                       
var lastSearch = "";
var mouseInResultBox = false;
var searchBoxOnfocus = false;
var searchBoxEmpty = false;
var noResult = false;
var min_marks = 100;
var max_result_items = 10;

//console.log(min_marks, max_result_items);

function searchFAQ(q) {
  console.log(getdom("#search-result-inner"));
  
  $("#search-result-inner").html("");
  if (q.length <= 1) {
    noResult = false;
    return;
  }
 
  var matchedNum = getMatchedNumber(q, min_marks, max_result_items);
 
  console.log(matchedNum); 
                   
  if (matchedNum == null) {
    noResult = false;
    return;
  }

  var res_html = '<div class="res-item"><div class="res-cat">|catalog|(|marks|)</div><div class="res-qst">|question|</div><div class="res-ans">|ans|</div></div>';
  var html = '';

  for (var j = 0; j < matchedNum; j++) {
    var k = words[j].k, i = words[j].i;
    var ans = md2html(catList[k][i].answer);
    if (catList[k][i].answer1 != null && catList[k][i].answer1 != "") ans += "<br><br><span class='ans-dept'>Hong Kong:</span><br>" + md2html(catList[k][i].answer1);
    if (catList[k][i].answer2 != null && catList[k][i].answer2 != "") ans += "<br><br><span class='ans-dept'>MDF:</span><br>" + md2html(catList[k][i].answer2);
    if (catList[k][i].answer3 != null && catList[k][i].answer3 != "") ans += "<br><br><span class='ans-dept'>Others:</span><br>" + md2html(catList[k][i].answer3);

    if (ans == null || ans == "") ans = "Please contact us for more information.";

    html += res_html.replace(/\|[^\|]*\|/g, function (m) {
      var pm = m.replace(/\|/g, '');
      if (catList[k][i].hasOwnProperty(pm)) {
        return catList[k][i][pm];
      } else {
        switch (pm) {
          case "ans": return ans;
          case "marks": return words[j].marks;
        }
      }
      return m;
    });
  }

  noResult = (html == "");
  $("#search-result-inner").html(html);
  //updateResultDisp();
}
  

//FAQ -PART 
  function htmlDecode(input) {
    if (input.length <= 0) return input;
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes[0].nodeValue;
  }

  function md2html(md) {
    var converter = new showdown.Converter();
    var html = converter.makeHtml(htmlDecode(md));
    return html;
  }
  var dataReady = false;
  
  function getFaqData(fn) {
    var data = { cmd: 'select', table: 'faq', filter: 'visible=1', 'sort': 'catalog,seq' };
    ajaxGet(guid(), 'https://glpopsys.com/glstore/db/dba', data, function (b) {
      faqdata = b.value;
      catList = getCatalogList();
      buildWordIndex();
      if (typeof fn != "undefined") fn(b.value);
    });
  }

  $("#topic_filter").on("input", function () {
    var keyword = $(this).val();
    searchBoxEmpty = (keyword == "");
    setTimeout(function () {
      if (lastSearch == keyword) searchFAQ(lastSearch);
    }, 500);
    lastSearch = keyword;
  });
  $("#topic_filter").focus(function () {
    searchBoxOnfocus = true;
  });
  $("#topic_filter").blur(function () {
    searchBoxOnfocus = false;
  });
                         
  $(document).ready(function() {
    var url = new URL(window.location.href);
    var keyword = url.searchParams.get("q");     
    searchBoxEmpty = (keyword == "");
    getFaqData(function (lst) {
      dataReady = true;
      searchFAQ(keyword);
    });
  }); 
//FAQ -PART

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topicGrid"] && !window.DesignMode) return;
  try {
    
function makeCollapsible() {
  var coll = document.getElementsByClassName("collapsible");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        var pp = $(this).parent().parent();
        setTimeout(function () {
          var tm = pp.get()[0].scrollHeight;
          pp.css("max-height", Math.max(300, tm));
        }, 300);
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        //check parent height
        updateGirdItemMaxHeight(content);
      }
    });
  }
}
function updateGirdItemMaxHeight(dom) {
  var mh = 70;
  var pp = $(dom).parent().parent();
  if ((pp.get()[0].scrollHeight + mh) > 300) {
    if (parseFloat(pp.css("max-height")) < 1200) {
      pp.css("max-height", pp.get()[0].scrollHeight + mh);
    }
  }
}

function fetchFaqItem() {
  var patt = '<button id="btn_|faqID|" class="collapsible">|question|</button><div class="content">|ans|</div>';
  for (var k in catList) {
    var tmpHTML = "";
    for (var i = 0; i < catList[k].length; i++) {
      var ans = md2html(catList[k][i].answer);
      if (catList[k][i].answer1 != null && catList[k][i].answer1 != "") ans += "<br><br><span class='ans-dept'>Hong Kong:</span><br>" + md2html(catList[k][i].answer1);
      if (catList[k][i].answer2 != null && catList[k][i].answer2 != "") ans += "<br><br><span class='ans-dept'>MDF:</span><br>" + md2html(catList[k][i].answer2);
      if (catList[k][i].answer3 != null && catList[k][i].answer3 != "") ans += "<br><br><span class='ans-dept'>Others:</span><br>" + md2html(catList[k][i].answer3);
      if (ans == null || ans == "") ans = "Please contact us for more information.";

      tmpHTML += '<button id="btn_' + catList[k][i].faqID + '" class="collapsible">' + catList[k][i].question + '</button><div class="content">' + ans + '</div>';
    }
    $("#topic-" + k).html(tmpHTML);
  }
}

function initFAQTopic() {
  if (dataReady) {
    fetchFaqItem();
    makeCollapsible();
    $(".grid-item-bottom").each(function () {
      if ($(this).parent().height() >= 300) $(this).removeClass("hide");
    });
    $(".show-all-qust").each(function () {
      $(this).mousedown(function () {
        var pp = $(this).parent().parent();
        if ($(this).hasClass('show-qust')) {
          pp.css("max-height", 1200);
          $(this).removeClass('show-qust').addClass('hide-qust');
        } else {
          pp.css("max-height", 300);
          $(this).addClass('show-qust').removeClass('hide-qust');
        }
      });
    });
  } else {
    setTimeout(function () {
      initFAQTopic();
    }, 100);
  }
}

$(document).ready(function () {
  initFAQTopic();
});

  } catch(e) { console.error(e); }
})();

})();
